import { createContext, useContext, useState } from 'react';

import type { Theme } from '@/components/layout/common';
import type { Dispatch, ReactNode, SetStateAction } from 'react';

type NavControls = {
  scrollThreshold: number;
  themeOverride: Theme | null;
};

const NavContext = createContext<
  [NavControls, Dispatch<SetStateAction<NavControls>>]
>([{ scrollThreshold: 0, themeOverride: null }, () => null]);

interface NavContextProviderProps {
  children: ReactNode;
  defaultScrollThreshold?: number;
}

export const NavContextProvider = ({
  children,
  defaultScrollThreshold = 50,
}: NavContextProviderProps) => {
  const navControls = useState<NavControls>({
    scrollThreshold: defaultScrollThreshold,
    themeOverride: null,
  });

  return (
    <NavContext.Provider value={navControls}>{children}</NavContext.Provider>
  );
};

export const useNavContext = () => {
  return useContext(NavContext);
};
